import api from '@motionelements/core/src/api/base-api-v2';

const mainUrl = '/v2/artist/collections';

export const listCollectionsWithPage = async (params, axiosConfig) => {
  params = params || {};

  const config = {
    params: {
      ...api.getLocaleParams(),
      ...params,
    },
    ...(axiosConfig || {}),
  };
  return api.get(mainUrl, config);
};

export const listCollections = async (params, axiosConfig) => {
  params = params || {};

  const config = {
    params: {
      ...api.getLocaleParams(),
      ...params,
    },
    ...(axiosConfig || {}),
  };
  return api.get(mainUrl, config)
    .then(({ data: { data } }) => data);
};

export const getCollection = async (collectionId, params) => {
  // const url = `/v2/artist/collections/${collectionId}?fields[element]=edit`;
  const url = `/v2/artist/collections/${collectionId}`;
  const querys = {
    params: {
      ...api.getLocaleParams(),
      ...params,
    },
    // ...(axiosConfig || {}),
  };
  return api
    .request('get', url, querys);
  // .then(({ data: { data } }) => data);
};

export const getCollectionStats = async () => {
  const url = '/v2/artist/collections/stats';
  const querys = {
    // params: {
    //   ...api.getLocaleParams(),
    // },
  };
  return api
    .request('get', url, querys);
  // .then(({ data: { data } }) => data);
};

export const getCollectionsStats = async () => {
  const url = '/v2/artist/collections/stats';
  const querys = {
    // params: {
    //   ...api.getLocaleParams(),
    // },
  };
  return api
    .request('get', url, querys);
  // .then(({ data: { data } }) => data);
};

export const getCollectionItems = async (collectionId, params) => {
  // const url = `/v2/artist/collections/${collectionId}?fields[collections]=details`;
  const url = `/v2/artist/collections/${collectionId}/items`;
  // const url = `/v2/collections/${collectionId}/items`;
  const querys = {
    params: {
      ...api.getLocaleParams(),
      ...params,
    },
  };
  return api
    .request('get', url, querys);
  // .then(({ data: { data } }) => data);
};

export const addCollectionItems = async (collectionId, skus) => {
  // const url = `/v2/artist/collections/${collectionId}?fields[collections]=details`;
  const url = `/v2/artist/collections/${collectionId}/items/`;
  // const url = `/v2/collections/${collectionId}/items`;
  // const querys = {
  //   params: {
  //     ...api.getLocaleParams(),
  //   },
  // };
  return api
    .request('post', url, {
      data: { skus: skus },
    });
  // .then(({ data: { data } }) => data);
};

export const removeCollectionItem = async (collectionId, elementId) => {
  // const url = `/v2/artist/collections/${collectionId}?fields[collections]=details`;
  const url = `/v2/artist/collections/${collectionId}/items/${elementId}`;
  // const url = `/v2/collections/${collectionId}/items`;
  const querys = {
    // params: {
    //   ...api.getLocaleParams(),
    // },
  };
  return api
    .request('delete', url, querys);
  // .then(({ data: { data } }) => data);
};

export const removeCollectionItems = async (collectionId, skus) => {
  // const url = `/v2/artist/collections/${collectionId}?fields[collections]=details`;
  const url = `/v2/artist/collections/${collectionId}/items/`;
  // const url = `/v2/collections/${collectionId}/items`;
  // const querys = {
  //   params: {
  //     ...api.getLocaleParams(),
  //   },
  // };
  return api
    .request('delete', url, {
      data: { skus: skus },
    });
  // .then(({ data: { data } }) => data);
};

export const createCollection = async (data) => {
  // console.log('API updateCollectionItem: ', collectionId);
  const url = '/v2/artist/collections/';
  return api.request('post', url, {
    data,
  });
};

export const updateCollection = async (collectionId, data) => {
  // console.log('API updateCollectionItem: ', collectionId);
  const url = `/v2/artist/collections/${collectionId}`;
  return api.request('patch', url, {
    data,
  });
};

export const publishCollection = async (collectionId) => {
  const url = `/v2/artist/collections/${collectionId}/publish`;
  const request = api.request('post', url, {
    // data: { skus: skus },
  });
  return request;
};

export const unpublishCollection = async (collectionId) => {
  const url = `/v2/artist/collections/${collectionId}/unpublish`;
  const request = api.request('post', url, {
    // data: { skus: skus },
  });
  return request;
};

export const deleteCollection = async (collectionId) => {
  const url = `/v2/artist/collections/${collectionId}`;
  const request = api.request('delete', url, {
    // data: { skus: skus },
  });
  return request;
};
